/**
 * AEB功能开关-批量读取结果展示表单
 */
import React, { useEffect } from 'react';
import { Form, InputNumber, Row, Col, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { formSearchGutter } from '@/constants/common';

interface AebFunctionSwitchReadFormProps {
  data?: any; // 读取到的数据
}

const AebFunctionSwitchReadForm: React.FC<AebFunctionSwitchReadFormProps> = ({ data }) => {
  const [form] = Form.useForm();

  // 当数据变化时设置表单值
  useEffect(() => {
    const resultDataStr = data?.resultData || ''
    const resultData = resultDataStr ? JSON.parse(resultDataStr) : {};
    console.log('AebFunctionSwitchReadForm resultData:', resultData);
    form.setFieldsValue(resultData);
    // }
  }, [data, form]);

  // 带说明的标签组件
  const LabelWithTooltip = ({ label, tooltip }: { label: string; tooltip: string }) => (
    <span>
      {label}{' '}
      <Tooltip title={tooltip}>
        <QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
      </Tooltip>
    </span>
  );

  return (
    <Form form={form} layout="vertical">
      <Row gutter={formSearchGutter}>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="工作模式" tooltip="取值范围：0~15，0~3bit；0：无效；1：production；2：debuging；其他预留" />}
            name="working_mode"
          >
            <InputNumber disabled placeholder="工作模式" style={{ width: '100%' }} precision={0} min={0} max={15} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="感知类型配置" tooltip="取值范围：0~15，4~7bit；0：无效；1：单V；2：单Radar；3：1V1R融合；其他预留" />}
            name="perceptionTypeConfig"
          >
            <InputNumber disabled placeholder="感知类型配置" style={{ width: '100%' }} precision={0} min={0} max={15} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="车型配置" tooltip="取值范围：0~255，1：GEELY；2：CHERY；待补全" />}
            name="vehicleTypeConfigure"
          >
            <InputNumber disabled placeholder="车型配置" style={{ width: '100%' }} precision={0} min={0} max={255} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={formSearchGutter}>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="细分车型配置" tooltip="取值范围：0~255，1-1：GEELY_LE25；1-2：GEELY_E51；待补全" />}
            name="vehicleSubTypeConfigure"
          >
            <InputNumber disabled placeholder="细分车型配置" style={{ width: '100%' }} precision={0} min={0} max={255} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="LCC功能配置" tooltip="取值范围：0~1，0bit；0：功能关闭；1：功能开启" />}
            name="lccEnable"
          >
            <InputNumber disabled placeholder="LCC功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="LDP功能配置" tooltip="取值范围：0~1，1bit；0：功能关闭；1：功能开启" />}
            name="ldpEnable"
          >
            <InputNumber disabled placeholder="LDP功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={formSearchGutter}>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="LDW功能配置" tooltip="取值范围：0~1，2bit；0：功能关闭；1：功能开启" />}
            name="ldwEnable"
          >
            <InputNumber disabled placeholder="LDW功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="ACC功能配置" tooltip="取值范围：0~1，3bit；0：功能关闭；1：功能开启" />}
            name="accEnable"
          >
            <InputNumber disabled placeholder="ACC功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="AEB功能配置" tooltip="取值范围：0~1，4bit；0：功能关闭；1：功能开启" />}
            name="aebEnable"
          >
            <InputNumber disabled placeholder="AEB功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={formSearchGutter}>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="FCW功能配置" tooltip="取值范围：0~1，5bit；0：功能关闭；1：功能开启" />}
            name="fcwEnable"
          >
            <InputNumber disabled placeholder="FCW功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="HMW功能配置" tooltip="取值范围：0~1，6bit；0：功能关闭；1：功能开启" />}
            name="hmwEnable"
          >
            <InputNumber disabled placeholder="HMW功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="DMS功能配置" tooltip="取值范围：0~1，7bit；0：功能关闭；1：功能开启" />}
            name="dmdEnable"
          >
            <InputNumber disabled placeholder="DMS功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={formSearchGutter}>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="左侧BSD功能配置" tooltip="取值范围：0~1，8bit；0：功能关闭；1：功能开启" />}
            name="bsdLeftEnable"
          >
            <InputNumber disabled placeholder="左侧BSD功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="右侧BSD功能配置" tooltip="取值范围：0~1，9bit；0：功能关闭；1：功能开启" />}
            name="bsdRightEnable"
          >
            <InputNumber disabled placeholder="右侧BSD功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="RVC功能配置" tooltip="取值范围：0~1，10bit；0：功能关闭；1：功能开启" />}
            name="rvcEnable"
          >
            <InputNumber disabled placeholder="RVC功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={formSearchGutter}>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="限速提醒功能配置" tooltip="取值范围：0~1，0bit；0：功能关闭；1：功能开启" />}
            name="slifEnable"
          >
            <InputNumber disabled placeholder="限速提醒功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="车速交通标志识别功能配置" tooltip="取值范围：0~1，1bit；0：功能关闭；1：功能开启" />}
            name="sliEnable"
          >
            <InputNumber disabled placeholder="车速交通标志识别功能配置" style={{ width: '100%' }} precision={0} min={0} max={1} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="AEB功能灵敏度配置" tooltip="取值范围：1~10，0~3bit；数值越大，AEB制动越积极、频繁" />}
            name="sensitivityAeb"
          >
            <InputNumber disabled placeholder="AEB功能灵敏度配置" style={{ width: '100%' }} precision={0} min={1} max={10} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={formSearchGutter}>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="FCW功能灵敏度配置" tooltip="取值范围：1~10，4~7bit；数值越大，FCW制动越积极、频繁" />}
            name="sensitivityFcw"
          >
            <InputNumber disabled placeholder="FCW功能灵敏度配置" style={{ width: '100%' }} precision={0} min={1} max={10} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="HMW功能灵敏度配置" tooltip="取值范围：1~10，0~3bit；数值越大，HMW制动越积极、频繁" />}
            name="sensitivityHmw"
          >
            <InputNumber disabled placeholder="HMW功能灵敏度配置" style={{ width: '100%' }} precision={0} min={1} max={10} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="ACC功能灵敏度配置" tooltip="取值范围：1~10，4~7bit；数值越大，ACC反应越灵敏" />}
            name="sensitivityAcc"
          >
            <InputNumber disabled placeholder="ACC功能灵敏度配置" style={{ width: '100%' }} precision={0} min={1} max={10} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={formSearchGutter}>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="LDW功能灵敏度配置" tooltip="取值范围：1~10，0~3bit；数值越大，LDW制动越积极、频繁" />}
            name="sensitivityLdw"
          >
            <InputNumber disabled placeholder="LDW功能灵敏度配置" style={{ width: '100%' }} precision={0} min={1} max={10} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="LDP功能灵敏度配置" tooltip="取值范围：1~10，4~7bit；数值越大，LDP触发越积极、频繁" />}
            name="sensitivityLdp"
          >
            <InputNumber disabled placeholder="LDP功能灵敏度配置" style={{ width: '100%' }} precision={0} min={1} max={10} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="LCC功能灵敏度配置" tooltip="取值范围：1~10，0~3bit；数值越大，LCC制动越积极、频繁" />}
            name="sensitivityLcc"
          >
            <InputNumber disabled placeholder="LCC功能灵敏度配置" style={{ width: '100%' }} precision={0} min={1} max={10} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={formSearchGutter}>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="DMS功能灵敏度配置" tooltip="取值范围：1~10，4~7bit；数值越大，DMS制动越积极、频繁" />}
            name="sensitivityDms"
          >
            <InputNumber disabled placeholder="DMS功能灵敏度配置" style={{ width: '100%' }} precision={0} min={1} max={10} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="左侧BSD功能灵敏度配置" tooltip="取值范围：1~10，0~3bit；数值越大，BSD制动越积极、频繁" />}
            name="sensitivityBsdLeft"
          >
            <InputNumber disabled placeholder="左侧BSD功能灵敏度配置" style={{ width: '100%' }} precision={0} min={1} max={10} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="右侧BSD功能灵敏度配置" tooltip="取值范围：1~10，4~7bit；数值越大，BSD制动越积极、频繁" />}
            name="sensitivityBsdRight"
          >
            <InputNumber disabled placeholder="右侧BSD功能灵敏度配置" style={{ width: '100%' }} precision={0} min={1} max={10} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={formSearchGutter}>
        <Col span={8}>
          <Form.Item
            label={<LabelWithTooltip label="RVC功能灵敏度配置" tooltip="取值范围：1~10，0~3bit；数值越大，RVC制动越积极、频繁" />}
            name="sensitivityRvc"
          >
            <InputNumber disabled placeholder="RVC功能灵敏度配置" style={{ width: '100%' }} precision={0} min={1} max={10} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default AebFunctionSwitchReadForm;
